import React, { Component } from 'react';
import Base from '../rebase';
import { } from 'react-bootstrap';
import PropTypes from 'prop-types';
import PageComponent from './page_components/PageComponent';

class Page extends Component {

  constructor(props) {
    super(props);
    this.state = {
      components: [],
    };
  }

  componentWillMount() {
    this.ref = Base.fetch('pages/' + this.props.page + '/components', {
      context: this,
      asArray: true,
      queries: {
        orderByChild: 'order'
      }
    })
    .then(data => {
      this.setState({components: data});
      console.log(this.ref);
    })
    .catch(error => {
      console.log("Page.jsx" + error);
    });
  }

  render() {
    return (
      <div className="container">
        {
          this.state.components.map((component, index) => (
            <PageComponent component={component} logout={this.props.logout}/>
            ))
        }
      </div>
      );
  }

}

Page.propTypes = {
	  page: PropTypes.string.isRequired
}

export default Page;



// WEBPACK FOOTER //
// ./src/reusable_components/Page.jsx